import actionCreator from 'helpers/actionCreator'
import { ADD_MESSAGE, CLEAR_MESSAGE, MESSAGE } from 'actions/messageActionTypes'

/** Called as an action when starting the remove message action */
export const messageAction = actionCreator(MESSAGE, 'key', 'message')

/** Called as an action when adding a message */
export const addMessageAction = actionCreator(ADD_MESSAGE, 'key', 'message')

/** Called as an action when clearing a message */
export const clearMessageAction = actionCreator(CLEAR_MESSAGE, 'key', 'message')



// WEBPACK FOOTER //
// ./src/actions/messageActions.js